<template>
    <div class="card-empty-state-challenge-select-user">
        <span class="card-empty-state-challenge-select-user__art"></span>
        <h2 class="card-empty-state-challenge-select-user__heading">Kullanıcı Yok</h2>
        <p class="card-empty-state-challenge-select-user__desc">Aradığın isimde biri bulunamadı.</p>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/card-empty-state-challenge-select-user.css"></style>